export { default as activateTab } from './actions/activateTab';
export { default as addTab } from './actions/addTab';
export { default as closeTab } from './actions/closeTab';
export { default as setTabIsShown } from './actions/setTabIsShown';

// Register orchestrator
import './actions/activateTabOrchestrator';
